const AVATAR_COLORS = ['#37F15F', '#FF6978', '#CDB9F9', '#FFDE1B', '#1DD0B4', '#90AFFF'];

export function getAvatarColor(id: string): string {
    let hash = 0;
    for (let i = 0; i < id.length; i++) {
        hash = Math.imul(31, hash) + id.charCodeAt(i);
    }
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}
